import { fromJS } from 'immutable';

const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';

export const userLoginReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case LOGIN_SUCCEEDED: {
      return action.data;
    }
    default:
      return state;
  }
};

export const dispatchLoginData = (userData) => ({
  type: LOGIN_SUCCEEDED,
  data: userData,
});
